import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import { Row } from "react-bootstrap";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import IOBBenefits from "./IOBBenefits";
import IOBFeatures from "./IOBFeatures";
// Main component for Agrifood Stack
export default function IoBStack() {
  
  // Data for the first section (features related to IoB stack)
  const data1 = [
    "Content Server: The content server facilitates the management of content within the category, allowing users to upload various media types like images and videos. It includes features such as setting expiry dates for content, detailed descriptions, and attribution to content creators, ensuring organized and relevant information for users in the purchasing sector.",
    "Agri Product Management: Agri Product Management facilitates the creation and sale of various agricultural products, including raw, semi-processed, and processed goods, as well as animal and plant care products.",
    "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
  ];

  // Data for the second section (technical services supporting the IoB stack)
  const data2 = [
    "S3: S3 is used for scalable, durable, and reliable cloud storage, allowing users to securely store and retrieve data of any size from anywhere on the web.",
    "DB: The database (DB) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle="Agrifood Stack"
        bannerbodycopy="Asset Behaviour | Site Behaviour | Actors Behaviour"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="Agrifood" />

      {/* Features Section */}
      <Container>
        <Row>
          <OverviewFeatures data1={data1} data2={data2} />
        </Row>
      </Container>

      {/* Agrifood Stack Features Section */}
      <IOBFeatures />

      {/* Agrifood Stack Benefits Section */}
      <IOBBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href4="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}

